const styles = (theme) => ({
	container: {
		width: "100%",
		alignItems: "center",
		flexDirection: "column",
		display: "flex",
	},
	paper: {
		display: "flex",
		width: "100%",
		borderRadius: "16px",
		overflow: "hidden",
		// alignItems: "center",
		// width: "100%",
		// justifyContent: "center",
		// display: "flex",
		// flexDirection: "column",
		// gap: 3,
		// width: "100%",
		// overflowX: "auto",
		// position: "relative",
		// backgroundColor: theme.palette.background.paper,
		// borderRadius: "16px",
		// overflow: "hidden",
	},
	BoxStack: {
		display: "flex",
		flexDirection: "row",
		padding: "20px 20px 0px 20px",
		alignItems: "center",
		justifyContent: "space-between",
		width: "100%",
		flexWrap: "wrap",
		gap: 2,
	},
	containerBuscar: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	containerAcoes: {
		display: "flex",
		flexWrap: "wrap",
		gap: 2,
	},
	selectRow: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
	},
	containerButton: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	containerAdd: {
		marginTop: "-3px",
	},
	conatinerChip: {
		height: "100%",
		display: "flex",
		alignItems: "center",
	},
	chipPermissoes: {
		// backgroundColor: "chip.waitingReview",
		height: "22px",
		fontWeight: 500,
		color: theme.palette.white.main,
		width: "140px",
		height: "25px",
	},
	containerPrimeiroAcesso: {
		cursor: "pointer",
		position: "relative",
		display: "flex",
		alignItems: "center",
		height: "100%",
	},
	containerIconTime: {
		fontSize: "15px",
		color: theme.palette.colors.orange.medium,
		zIndex: 1,
		position: "absolute",
		bottom: 4,
		left: 11,
		bottom: 16,
		borderRadius: "50%",
		backgroundColor: "background.paper",
	},
	containerAvatar: {
		width: "35px",
		height: "35px",
	},
	person: {
		color: theme.palette.colors.green.light,
	},
	personOff: {
		color: theme.palette.colors.orange.medium,
	},
	dataGrid: {
		display: "grid",
		"&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
			py: "5px",
		},
		"&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {},
		"&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
			py: "22px",
		},
		fontSize: 15,
		"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
			outline: "none !important",
		},
	},
	searcField: {
		width: "250px",
		display: "flex",
		fontSize: "0.90rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "8px 10px", // padding interno reduzido
			fontSize: "0.90rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.90rem", // fonte da label
		},
		"@media (max-width: 1350px)": {
			width: "100%",
		},
	},
	clientAutocomplete: {
		width: "200px",
		fontSize: "0.90rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "8px 10px", // padding interno reduzido
			fontSize: "0.90rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.90rem", // fonte da label
		},
	},
	boxSearchFields: {
		display: "flex",
		flexDirection: "row",
		gap: 2,
		"@media (max-width: 1350px)": {
			flexDirection: "column",
		},
	},
	buttonNewClient: {
		color: theme.palette.text.main,
		borderColor: theme.palette.text.main,
		maxWidth: "200px",
		"@media (max-width: 1350px)": {
			maxWidth: "200px",
		},
	},
	containerDataGrid: { display: "flex", width: "100%" },
});

export default styles;
